import "./dashboard-sections.css";

const DUMMY = {
  kg_night_taken_off: 12000,
  total_kg_taken_off: 58600,
  boxes_fruit:        1200,
  boxes_paste:        800,
};

const OutputBox = ({ label, value, unit = "" }) => (
  <div className="pod-box">
    <div className="pod-box-label">{label}</div>
    <div className="pod-box-value">
      {value?.toLocaleString()}{unit && <span className="db-metric-unit"> {unit}</span>}
    </div>
  </div>
);

const ProductionOutputDetails = ({ data = DUMMY, isLoading = false }) => (
  <div className="cmn_card pod-card">
    <div className="pod-header">Production Output Details</div>
    <div className="pod-grid">
      <OutputBox label="KG NIGHT TAKEN OFF" value={data.kg_night_taken_off} unit="kg" />
      <OutputBox label="TOTAL KG TAKEN OFF"  value={data.total_kg_taken_off} unit="kg" />
      <OutputBox label="BOXES FRUIT"          value={data.boxes_fruit} />
      <OutputBox label="BOXES PASTE"          value={data.boxes_paste} />
    </div>
  </div>
);

export default ProductionOutputDetails;
